import { Container, Button } from "react-bootstrap";
import React from "react";
import { useNavigate } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { Autoplay } from "swiper/modules";
import { motion } from "framer-motion";
import "./StoreStrip.css";

const platforms = [
  { img: "/Images/partner/Spotify.webp", alt: "Spotify" },
  { img: "/Images/partner/apple.webp", alt: "Apple Music" },
  { img: "/Images/partner/YouTube01.webp", alt: "YouTube Music" },
  { img: "/Images/partner/resso.webp", alt: "JioSaavn" },
  { img: "/Images/partner/Deezer_logo.webp", alt: "Deezer" },
  { img: "/Images/partner/amazon.webp", alt: "Amazon Music" },
  { img: "/Images/partner/instagram.webp", alt: "Instagram" },
  { img: "/Images/partner/tiktok.webp", alt: "TikTok" },
];

const StoreStrip = () => {
  const navigate = useNavigate();

  return (
    <div className="store-strip-premium">
      <Container fluid className="px-md-5 px-3">
        {/* Top Label */}
        <motion.div 
          className="d-flex justify-content-center align-items-center mb-4"
          initial={{ opacity: 0, scale: 0.9 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          <div className="strip-line"></div>
          <div className="strip-label mx-3">GET YOUR MUSIC ON</div>
          <div className="strip-line"></div>
        </motion.div>

        {/* Bottom Content: Slider + Button */}
        <div className="d-flex align-items-center justify-content-between flex-wrap flex-lg-nowrap gap-4">
          <motion.div 
            className="slider-container flex-grow-1" style={{ minWidth: 0 }}
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <Swiper
              spaceBetween={30}
              slidesPerView={3}
              loop={true}
              autoplay={{
                delay: 2000,
                disableOnInteraction: false,
              }}
              modules={[Autoplay]}
              breakpoints={{
                576: { slidesPerView: 4, spaceBetween: 20 },
                768: { slidesPerView: 5, spaceBetween: 30 },
                992: { slidesPerView: 6, spaceBetween: 40 },
                1200: { slidesPerView: 7, spaceBetween: 40 },
              }}
              className="stores-swiper"
            >
              {platforms.map((p, i) => (
                <SwiperSlide
                  key={i}
                  className="d-flex justify-content-center align-items-center"
                >
                  <img src={p.img} alt={p.alt} className="platform-logo-img" />
                </SwiperSlide>
              ))}
            </Swiper>
          </motion.div>

          <motion.div 
            className="flex-shrink-0 ms-lg-3 mx-auto"
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.2 }}
          >
            <Button
              className=" button_button__MFmXH button_color__bLscP"
              style={{ border: "none", fontSize: "14px" }}
              onClick={() => navigate("/music-stores")}
            >
              View All 150+ Stores
            </Button>
          </motion.div>
        </div>
      </Container>
    </div>
  );
};

export default StoreStrip;
